<template lang="html">
	<div class="inner-modal">
		<div class="head-modal">
			<div class="head-modal-title">
				Indisponibilité
			</div>
			<div class="head-modal-emphase">
				Ajouter un message d'absence pour vos clients
			</div>
		</div>
		<div class="body-modal">
			<form class="form-ui default-form-ui need-big">
				<div class="form-elem-container">
					<div class="ctn-textarea ctn-label column" v-inputUI :class="{error: errors.has('message')}">
						<label for="message">Message d'absence</label>
						<textarea v-validate="'required'" v-model="message" name="message"></textarea>
					</div>
					<div class="error-message" v-if="errors.has('message')">
						{{ errors.first('message')}}
					</div>
				</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="save">Sauvegarder</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'ModalUnavailable',
	data () {
		return {
			message: null
		}
	},
	methods: {
		close () {
			this.$emit('close')
		},
		save () {
			this.$store.dispatch('setAvailable', {
				user_id: this.user.id,
				available: 0,
				ooo_message: this.message
			}).then(() => {
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Votre disponibilité a été mise à jour',
					text: ''
				})
				this.$emit('close')
			}).catch(() => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Votre disponibilité n\'a pas pu être mise à jour',
					text: ''
				})
			})
		}
	},
	computed: {
		...mapGetters({
			user: 'user'
		})
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// Unavailable.vue?424a9d77